export const POSTS_PER_PAGE = 6;

export function clampPage(raw: string | string[] | undefined, totalPages: number): number {
  const value = Array.isArray(raw) ? raw[0] : raw;
  const parsed = Number.parseInt(value ?? "1", 10);
  if (Number.isNaN(parsed) || parsed < 1) {
    return 1;
  }
  return Math.min(parsed, Math.max(totalPages, 1));
}

export function blogPageHref(page: number, showAllLanguages: boolean): string {
  const params = new URLSearchParams();
  if (showAllLanguages) {
    params.set("lang", "all");
  }
  if (page > 1) {
    params.set("page", String(page));
  }
  const query = params.toString();
  return query ? `/blog?${query}` : "/blog";
}
